import BasicTableTab from "features/commitments/tabs/BasicTableTab";
import { InvestorTabProps } from "features/investors/InvestorTabProps";
import { useCommitmentInformationTableDataByFundRetrieveSuspense } from "gen/endpoints/commitment-information-table-data-by-fund/commitment-information-table-data-by-fund";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";

export const InvestorTabFunds: React.FC = () => {
  const { t } = useTranslation(["investorEntity", "common", "investor"]);

  const { investorId } = useOutletContext<InvestorTabProps>();

  const { data: tableData } =
    useCommitmentInformationTableDataByFundRetrieveSuspense({
      investor_id: investorId,
    });

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(
    ({ row }) =>
      row.data?.metadata?.type === "id_row" &&
      row.data.granularity_level === "security_ownership" &&
      row.data.cells["fund_family_id"].value?.type === "text" &&
      row.data.cells["fund_family_id"].value.text
        ? {
            type: "generic",
            to: rootRoute({})
              .fundFamilies({})
              .fundFamily({
                fundFamilyId: row.data.cells["fund_family_id"].value.text,
              })
              .commitments({})
              .commitment({ commitmentId: row.data.metadata.id })
              .activity({}).$,
          }
        : undefined,
    [],
  );

  return (
    <BasicTableTab
      tableTitle={t("investor:tabs.funds.table.title")}
      emptyStateProps={{
        title: t("investor:tabs.funds.table.empty.title"),
        description: t("investor:tabs.funds.table.empty.description"),
      }}
      data={tableData}
      getLinkInfoForRow={getLinkInfoForRow}
    />
  );
};
